import { render } from "./letter-topic-attachment.vue?vue&type=template&id=2eaea8fd"
import script from "./letter-topic-attachment.vue?vue&type=script&lang=js"
export * from "./letter-topic-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__